var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpaqueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconAdicionales/Empaque"
  }, /*#__PURE__*/React.createElement("path", {
    id: "IconAdicionales/Empaque_2",
    d: "M15.5223 4.70424L8.15622 9.40848L15.5223 14.1127L8.15622 18.817L0.767822 14.0681L8.15064 9.36384L0.767822 4.70424L8.15064 0L15.5223 4.70424ZM8.11157 20.2958L15.4776 15.5915L22.8437 20.2958L15.4776 25L8.11157 20.2958ZM15.5223 14.0681L22.8884 9.36384L15.5223 4.69866L22.8493 0L30.2321 4.70424L22.8493 9.40848L30.2321 14.1071L22.8493 18.8114L15.5223 14.0681Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpaqueIcon);
export default __webpack_public_path__ + "static/media/empaque_icon.016940c9632f637fd39a0f34621d4e42.svg";
export { ForwardRef as ReactComponent };